<template>
    <div class="popup-wrap p-f" @click="closePop">
        <div class="popup p-a t-a-c" :style="{backgroundImage:'url('+info.pop_bg+')'}">
            <a class="d-b p-a close-btn" href="javascript:;" :style="{backgroundImage:'url('+info.btn_close+')'}" v-if="info.btn_close"></a>
            <h1 class="mb-f-s-lx default-color" v-if="info.text_o">{{info.text_o}}</h1>
            <h2 class="mb-f-s-lx default-color" v-if="info.text_s">{{info.text_s}}</h2>
            <img class="pop-content d-i-b" :src="info.content" alt="">
            <h3 class="mb-f-s-l default-color" v-if="info.text_t">{{info.text_t}}</h3>
            <h3 class="mb-f-s-l default-color" v-if="info.text_f">{{info.text_f}}</h3>
        </div>
    </div>
</template>
<style lang="less">
    .popup-wrap {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .8);
        z-index: 2;
    }
    .popup {
        width: 8.586667rem;
        height: 8.586667rem;
        background-size: 100% 100%;
        top: 50%;
        left: 50%;
        margin: -5.95rem 0 0 -4.29rem;
        .close-btn {
            width: 1.133333rem;
            height: .666667rem;
            top: 0;
            right: 0;
            background-size: 100% 100%;
        }
    }
</style>
<script>
    export default {
        props: ['info'],
        methods: {
            closePop() {
                this.$emit("closePop");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/components/common/alert/index.vue